/**
 * @fileoverview gRPC-Web generated client stub for billing.private.customer
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_timestamp_pb from 'google-protobuf/google/protobuf/timestamp_pb';

import {
  AddCustomerNoteRequest,
  AddCustomerNoteResponse,
  AdminUpdateCustomerCardDetailsScaRequest,
  AdminUpdateCustomerCardDetailsScaResponse,
  DeleteCustomerNoteRequest,
  DeleteCustomerNoteResponse,
  GetCustomerCardDetailsRequest,
  GetCustomerCardDetailsResponse,
  GetCustomerLanguageRequest,
  GetCustomerLanguageResponse,
  GetCustomerNotesRequest,
  GetCustomerNotesResponse,
  GetViesVatValidationsRequest,
  GetViesVatValidationsResponse,
  UpdateCustomerLanguageRequest,
  UpdateCustomerLanguageResponse,
  UpdateCustomerNoteRequest,
  UpdateCustomerNoteResponse,
  UpdateCustomerPaymentDetailsScaRequest,
  UpdateCustomerPaymentDetailsScaResponse} from './customer_pb';

export class CustomerServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetCustomerCardDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCustomerCardDetailsResponse,
    (request: GetCustomerCardDetailsRequest) => {
      return request.serializeBinary();
    },
    GetCustomerCardDetailsResponse.deserializeBinary
  );

  getCustomerCardDetails(
    request: GetCustomerCardDetailsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetCustomerCardDetailsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/GetCustomerCardDetails',
      request,
      metadata || {},
      this.methodInfoGetCustomerCardDetails,
      callback);
  }

  methodInfoGetViesVatValidations = new grpcWeb.AbstractClientBase.MethodInfo(
    GetViesVatValidationsResponse,
    (request: GetViesVatValidationsRequest) => {
      return request.serializeBinary();
    },
    GetViesVatValidationsResponse.deserializeBinary
  );

  getViesVatValidations(
    request: GetViesVatValidationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetViesVatValidationsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/GetViesVatValidations',
      request,
      metadata || {},
      this.methodInfoGetViesVatValidations,
      callback);
  }

  methodInfoUpdateCustomerPaymentDetailsSca = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateCustomerPaymentDetailsScaResponse,
    (request: UpdateCustomerPaymentDetailsScaRequest) => {
      return request.serializeBinary();
    },
    UpdateCustomerPaymentDetailsScaResponse.deserializeBinary
  );

  updateCustomerPaymentDetailsSca(
    request: UpdateCustomerPaymentDetailsScaRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateCustomerPaymentDetailsScaResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/UpdateCustomerPaymentDetailsSca',
      request,
      metadata || {},
      this.methodInfoUpdateCustomerPaymentDetailsSca,
      callback);
  }

  methodInfoAdminUpdateCustomerCardDetailsSca = new grpcWeb.AbstractClientBase.MethodInfo(
    AdminUpdateCustomerCardDetailsScaResponse,
    (request: AdminUpdateCustomerCardDetailsScaRequest) => {
      return request.serializeBinary();
    },
    AdminUpdateCustomerCardDetailsScaResponse.deserializeBinary
  );

  adminUpdateCustomerCardDetailsSca(
    request: AdminUpdateCustomerCardDetailsScaRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AdminUpdateCustomerCardDetailsScaResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/AdminUpdateCustomerCardDetailsSca',
      request,
      metadata || {},
      this.methodInfoAdminUpdateCustomerCardDetailsSca,
      callback);
  }

  methodInfoAddCustomerNote = new grpcWeb.AbstractClientBase.MethodInfo(
    AddCustomerNoteResponse,
    (request: AddCustomerNoteRequest) => {
      return request.serializeBinary();
    },
    AddCustomerNoteResponse.deserializeBinary
  );

  addCustomerNote(
    request: AddCustomerNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AddCustomerNoteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/AddCustomerNote',
      request,
      metadata || {},
      this.methodInfoAddCustomerNote,
      callback);
  }

  methodInfoUpdateCustomerNote = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateCustomerNoteResponse,
    (request: UpdateCustomerNoteRequest) => {
      return request.serializeBinary();
    },
    UpdateCustomerNoteResponse.deserializeBinary
  );

  updateCustomerNote(
    request: UpdateCustomerNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateCustomerNoteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/UpdateCustomerNote',
      request,
      metadata || {},
      this.methodInfoUpdateCustomerNote,
      callback);
  }

  methodInfoDeleteCustomerNote = new grpcWeb.AbstractClientBase.MethodInfo(
    DeleteCustomerNoteResponse,
    (request: DeleteCustomerNoteRequest) => {
      return request.serializeBinary();
    },
    DeleteCustomerNoteResponse.deserializeBinary
  );

  deleteCustomerNote(
    request: DeleteCustomerNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DeleteCustomerNoteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/DeleteCustomerNote',
      request,
      metadata || {},
      this.methodInfoDeleteCustomerNote,
      callback);
  }

  methodInfoGetCustomerNotes = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCustomerNotesResponse,
    (request: GetCustomerNotesRequest) => {
      return request.serializeBinary();
    },
    GetCustomerNotesResponse.deserializeBinary
  );

  getCustomerNotes(
    request: GetCustomerNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetCustomerNotesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/GetCustomerNotes',
      request,
      metadata || {},
      this.methodInfoGetCustomerNotes,
      callback);
  }

  methodInfoGetCustomerLanguage = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCustomerLanguageResponse,
    (request: GetCustomerLanguageRequest) => {
      return request.serializeBinary();
    },
    GetCustomerLanguageResponse.deserializeBinary
  );

  getCustomerLanguage(
    request: GetCustomerLanguageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetCustomerLanguageResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/GetCustomerLanguage',
      request,
      metadata || {},
      this.methodInfoGetCustomerLanguage,
      callback);
  }

  methodInfoUpdateCustomerLanguage = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateCustomerLanguageResponse,
    (request: UpdateCustomerLanguageRequest) => {
      return request.serializeBinary();
    },
    UpdateCustomerLanguageResponse.deserializeBinary
  );

  updateCustomerLanguage(
    request: UpdateCustomerLanguageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateCustomerLanguageResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.customer.CustomerService/UpdateCustomerLanguage',
      request,
      metadata || {},
      this.methodInfoUpdateCustomerLanguage,
      callback);
  }

}

